import React from 'react'

import { t } from 'i18next'
import {
  connect,
  currentPage,
  currentPageParams,
  DataClass,
  navigateTo,
} from 'scrivito'

import { Button } from '@/Atomic/Molecules/Button'
import { DataClassDrawer } from '@/Atomic/Widgets/DataClassDrawer/DataClass.Drawer'

interface EntityAddCanvasButtonProps {
  dataClass: DataClass
}

export const EntityAddCanvasButton: React.FC<EntityAddCanvasButtonProps> =
  connect(({ dataClass }) => {
    const { drawer, drawer_id, ...rest } = currentPageParams()
    const isOpen =
      drawer === dataClass.name() && drawer_id === `new_${dataClass.name()}`

    const openModal = () => {
      navigateTo(currentPage(), {
        ...currentPageParams(),
        params: {
          drawer: dataClass.name(),
          drawer_id: `new_${dataClass.name()}`,
        },
      })
    }

    const closeModal = () => {
      navigateTo(currentPage(), rest)
    }

    return (
      <>
        <Button
          variant="primary"
          size="sm"
          icon="add"
          iconColor="white"
          iconSize="sm"
          onClick={openModal}
          data-testid={`${dataClass.name()}-add-button`}
        >
          {t('common.create')}
        </Button>

        <DataClassDrawer
          dataClass={dataClass}
          isOpen={isOpen}
          close={closeModal}
        />
      </>
    )
  })
